/**
 * @flow
 * @relayHash 939b1cb71ac8499bbd17caad0a805551
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowStateType = "archive" | "available" | "deleted" | "%future added value";
export type TVShowAddInput = {
  title: string,
  slug: string,
  isProject?: ?boolean,
  hideDescription?: ?boolean,
  preview?: ?string,
  previewPicture?: ?string,
  shortDescription: string,
  description: string,
  schedule: string,
  category: string,
  persons?: ?$ReadOnlyArray<?string>,
  hidden?: ?boolean,
  state: TVShowStateType,
  clientMutationId?: ?string,
};
export type TVShowAddMutationVariables = {|
  input: TVShowAddInput
|};
export type TVShowAddMutationResponse = {|
  +TVShowAdd: ?{|
    +tvshowEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type TVShowAddMutation = {|
  variables: TVShowAddMutationVariables,
  response: TVShowAddMutationResponse,
|};
*/


/*
mutation TVShowAddMutation(
  $input: TVShowAddInput!
) {
  TVShowAdd(input: $input) {
    tvshowEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowAddInput!"
      }
    ],
    "concreteType": "TVShowAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tvshowEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShowEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "TVShow",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowAddMutation",
  "id": null,
  "text": "mutation TVShowAddMutation(\n  $input: TVShowAddInput!\n) {\n  TVShowAdd(input: $input) {\n    tvshowEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a2777fc1079849dd25498c77bd554ad8';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowAddMutation.graphql.js